// 픽셀 아트 툴바 아이콘과 배치용 커서. 둘 다 순수 문자열이라 React에 기대지 않는다.

/** 툴바 버튼용: 2×2 칸. viewBox 0 0 20 20, stroke=currentColor. */
export const PIXEL_ART_ICON_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><rect x="2.75" y="2.75" width="6" height="6"/><rect x="11.25" y="2.75" width="6" height="6" fill="currentColor"/><rect x="2.75" y="11.25" width="6" height="6" fill="currentColor"/><rect x="11.25" y="11.25" width="6" height="6"/></svg>';

const cursorFromSvg = (svg: string) =>
  `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}") 16 16, crosshair`;

// 흰 테두리 패스를 한 겹 더 깔아 어두운 배경과 밝은 배경에서 모두 보이게 한다.
const cursorSvg = (outline: string, body: string) =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" stroke-linecap="round" stroke-linejoin="round">${outline}${body}</svg>`;

const PIXEL_CURSOR_PATHS =
  '<path d="M8 8h7v7H8zM17 8h7v7h-7zM8 17h7v7H8zM17 17h7v7h-7z"/>';

/** 픽셀 아트를 놓을 자리를 가리키는 커서. */
export const PIXEL_ART_PLACE_CURSOR = cursorFromSvg(
  cursorSvg(
    `<g stroke="#ffffff" stroke-width="5">${PIXEL_CURSOR_PATHS}</g>`,
    `<g stroke="#1b1b1f" stroke-width="2">${PIXEL_CURSOR_PATHS}</g>`,
  ),
);

// 코어 ImageIcon(packages/excalidraw/components/icons.tsx)의 path. 20×20 기준이라 32px 칸 가운데로 옮긴다.
const IMAGE_CURSOR_PATHS =
  '<g transform="translate(6 6)"><path d="M12.5 6.667h.01"/><path d="M4.91 2.625h10.18a2.284 2.284 0 0 1 2.285 2.284v10.182a2.284 2.284 0 0 1-2.284 2.284H4.909a2.284 2.284 0 0 1-2.284-2.284V4.909a2.284 2.284 0 0 1 2.284-2.284Z"/><path d="m3.333 12.5 3.334-3.333c.773-.745 1.726-.745 2.5 0l4.166 4.166"/><path d="m11.667 11.667.833-.834c.774-.744 1.726-.744 2.5 0l1.667 1.667"/></g>';

/** 이미지를 놓을 자리를 가리키는 커서. */
export const IMAGE_PLACE_CURSOR = cursorFromSvg(
  cursorSvg(
    `<g stroke="#ffffff" stroke-width="4.5">${IMAGE_CURSOR_PATHS}</g>`,
    `<g stroke="#1b1b1f" stroke-width="1.5">${IMAGE_CURSOR_PATHS}</g>`,
  ),
);
